import { Card } from '@/shared/components/ui/Card';

export function EmptyDashboard() {
  return (
    <Card padding="lg" className="text-center">
      <div className="py-12">
        <span className="text-6xl mb-4 block" role="img" aria-label="celebration">
          🎉
        </span>
        <h3 className="text-2xl font-semibold text-gray-900 mb-2">All Caught Up!</h3>
        <p className="text-gray-600 max-w-md mx-auto">
          You have no pending alerts or overdue items. Your frame replenishment workflow is running
          smoothly.
        </p>
      </div>
    </Card>
  );
}
